export default {
    namespaced: true,
    state: {
        curApp:null,
        sysConfig:null,
        isScanDialogVisable:true
    },
    mutations: {
        SET_CURAPP: (state, payload) => {
            state.curApp = payload
        },
        SET_SYSCONFIG: (state, payload) => {
            state.sysConfig = payload
        },
        SET_ScanDialogVisable: (state, payload) => {
            state.isScanDialogVisable = payload
        }
    },
    actions: {}
}
